module.exports = __webpack_public_path__ + "img/2.5fca0dd7.png";